import request from '@/utils/request'
// const request = function(){}
export function loadAll(category, options) {
  return request({
    url: '/api/config/'+category,
    method: 'get',
    params: options
  })
}
export function loadAllByType(type) {
  return request({
    url: '/api/config?type='+type,
    method: 'get'
  })
}